module.exports = __webpack_public_path__ + "img/music-player.55fdff80.png";